import { createBaseExportSchema } from '@app/modules/social-export/components/validation/useBaseExportSchema';
import { useMemo } from 'react';
import { IntlFormatters, useIntl } from 'react-intl';
import { z } from 'zod';

const DAILYMOTION_TITLE_MAX_LENGTH = 150;
const DAILYMOTION_DESCRIPTION_MAX_LENGTH = 3000;

/** Builds the Zod schema for the Dailymotion publish form. */
export function createDailymotionPublishSchema(t: IntlFormatters['$t']) {
  return createBaseExportSchema(t).extend({
    title: z.string().trim().min(1).max(DAILYMOTION_TITLE_MAX_LENGTH),
    content: z.string().trim().min(1).max(DAILYMOTION_DESCRIPTION_MAX_LENGTH),
    tags: z.string().optional(),
    forKids: z.boolean(),
    private: z.boolean(),
    thumbOffsetMs: z.number().nullable().optional(),
    channel: z
      .string()
      .nullable()
      .optional()
      .transform((val) => (val === '' ? null : val)),
  });
}

export type DailymotionPublishValues = z.infer<ReturnType<typeof createDailymotionPublishSchema>>;

/** Zod schema for the Dailymotion publish form with translated validation messages. */
export function useDailymotionPublishSchema() {
  const { $t } = useIntl();
  return useMemo(() => createDailymotionPublishSchema($t), [$t]);
}
